import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Output, EventEmitter } from '@angular/core';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class LearnerService {
  learners: any = [];

  private learnerSubject = new Subject<any>();
  private singleJobDetails = new Subject<any>();
  @Output() isSelected: EventEmitter<any> = new EventEmitter<any>();
  private newLearner = new Subject<any>();
  private newEvidence = new Subject<any>();
  private removeLearner = new Subject<any>();
  private removeEvidence = new Subject<any>();
  private editEvidences = new Subject<any>();
  private allocateLearnerStatusUpdate = new Subject<any>();
  public fileDetails = new Subject<any>();
  private markingScheme = new Subject<any>();
  constructor(private http: HttpClient) {
    this.learners = [];
    console.log("learners initialized!!!!!!!", this.learners)
  }
  newLearnerObservable(): Observable<any> {
    return this.newLearner.asObservable();
  }

  newEvidenceObservable(): Observable<any> {
    return this.newEvidence.asObservable();
  }
  addLearner(data: any): Observable<any> {
    console.log("Adding learners", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learners", data).subscribe((res: any) => {
        console.log("response of new learner added", res);
        this.newLearner.next({ learner: res.data.learner })
        observer.next(res.data.learner);

        observer.complete();
      }, err => {
        console.log("ERROR ", err)
        observer.error(err.msg);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }
  editLearner(data: any): Observable<any> {
    console.log("Edit learners", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "learners", data).subscribe((res: any) => {
        console.log("Edited Learner : ", res);
        observer.next(res.data.learner);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }


  allocateLearner(data: any): Observable<any> {
    console.log("Edit learners", data);
    let obj = { learner: data }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "learners/allot", obj).subscribe((res: any) => {
        console.log("Edited Learner : ", res);
        observer.next(res);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }


  allocateLearnerFromStatus(data: any): Observable<any> {
    console.log("ALLOTMENT data", data);

    let obj = { learner: data.allotArray, jobId: data.jobId }



    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "learners/allotment", obj).subscribe((res: any) => {
        console.log("alloted : ", res);
        observer.next(res);
        this.allocateLearnerStatusUpdate.next(res)
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  allocateLearnerFromStatusObservable(): Observable<any> {
    return this.allocateLearnerStatusUpdate.asObservable();
  }

  submitExamMarks(data: any): Observable<any> {
    console.log("submit Marks learners", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "learners/exam", data).subscribe((res: any) => {
        console.log("Edited Learner : ", res);
        observer.next(res.data.learner);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  getAllotedLearnerFilesUsingAllotmentId(id) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/allot?_id=" + id).subscribe((res: any) => {
        console.log("----------Alloted Learner data---------- : ", res);
        observer.next(res.data.allotment);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }



  getAllotedLearnerFiles(learnerId, assignmentId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/allot", learnerId + assignmentId).subscribe((res: any) => {
        console.log("----------Alloted Learner data---------- : ", res);
        observer.next(res.data.learner);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  deleteLearner(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "learners?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.learner);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }

  deleteAllotment(data) {
    console.log('Delete Allotment service', data)
    return new Observable((observer) => {
      this.http.put(config.baseApiUrl + "learners/allot-remove", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }

  getLearner(id, jobId): Observable<any> {
    console.log("Getting learners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners?_id=" + id + "&jobId=" + jobId).subscribe((res: any) => {
        console.log("Get learners : ", res);
        observer.next(res.data.learners);
        observer.complete();
      })
    });
  }


  getLearnersByJobId(jobId): Observable<any> {
    console.log("Getting learners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/job?job=" + jobId).subscribe((res: any) => {
        observer.next(res.data.learners);
        observer.complete();
      })

    });
  }



  getLearnersByJobIdV2(jobId): Observable<any> {
    console.log("Getting learners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/job?job=" + jobId).subscribe((res: any) => {
        observer.next(res.data.learners);
        observer.complete();
      })
    });
  }

  getAllotmentListUsingAssignmentId(assignmentId): Observable<any> {
    console.log("Getting learners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/allot-status?_id=" + assignmentId).subscribe((res: any) => {
        console.log("Get learners : ", res);
        observer.next(res.data.assignment);
        observer.complete();
      })

    });
  }


  submitAssignment(data: any): Observable<any> {
    console.log("Adding Files", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learners/submission", data).subscribe((res: any) => {

        observer.next(res.data.file);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }


  updateAssignmentAllotmentUsingAllotmentId(data: any): Observable<any> {
    console.log("Adding Files", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "learners/allot", data).subscribe((res: any) => {

        observer.next(res.data.file);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  downloadAssignmentReport(learnerId: any): Observable<any> {
    // alert(" Function call in services ")
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/assignment-report?learnerId=" + learnerId)
        .subscribe((res: any) => {
          console.log("Get Repoart data : ", res);
          observer.next(res.data);
          observer.complete();
        })

    });
  }

  downloadSubmissionsFiles(learnerId: any): Observable<any> {
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/submissions?learnerId=" + learnerId)
        .subscribe((res: any) => {
          console.log("Get Submissions Files data : ", res);
          observer.next(res.data);
          observer.complete();
        })

    });
  }
  getLearanerList(jobId) {
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable", jobId);
      this.http.post(config.baseApiUrl + "learners/list", jobId).subscribe((res: any) => {
        console.log("Get learners with all list : ", res);
        observer.next(res.response);
        observer.complete();
      })

    });
  }

  multipleLearnersInJob(data) {
    // let that = this;
    console.log("final data to be send", data)
    return new Observable<any>((observer) => {
      let that = this;
      this.http.post(config.baseApiUrl + "learners/assign-job", data).subscribe((res: any) => {
        console.log("when multiple learners added", res);

        observer.next(res);
        observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  removeLearnerObservable(): Observable<any> {
    return this.removeLearner.asObservable();
  }

  // Remove Learner From Job
  removeLearnerFromJob(learnerId, jobId) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "learners/remove?learnerId=" + learnerId + '&jobId=' + jobId).subscribe((res: any) => {
        console.log("response of remove leaner in job", res);

        observer.next(res.data);
        this.removeLearner.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }


  isChecked() {
    console.log('Is checked From Service');
    this.isSelected.emit('false');
  }


  // PORTFOLIO APIS START HERE
  // SUBMISSION
  getSessionSubmission(sessionId, sessionType, learnerId) {
    console.log("Getting learners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      // this.http.get(config.baseApiUrl + "learner-portfolio/submission?sessionId=" + sessionId + "&sessionType=" + sessionType + "&learnerId=" + learnerId).subscribe((res: any) => {
      //   console.log("Get learners : ", res);
      //   observer.next(res.data.assignment);
      observer.complete();
      // })

    });
  }

  updateSessionSubmission(data: any): Observable<any> {
    console.log("updateSessionSubmission", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "learner-portfolio/submission", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  // POLICY CONFIRMATION
  submitPolicy(data: any): Observable<any> {
    console.log("Adding Files", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learner-portfolio/policy", data).subscribe((res: any) => {
        if (data && data.type && data.type === 'markingScheme') this.markingScheme.next(res)
        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  markingSchemeSubmit(): Observable<any> {
    return this.markingScheme.asObservable();
  }
  evidenceRefPdf(data: any): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learner-portfolio/evidence-reference-pdf", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  // STATIC FORMS
  submitPortfolioForm(data: any): Observable<any> {
    console.log("Adding Files", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learner-portfolio/forms", data).subscribe((res: any) => {

        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  getPortfolioForms(learnerId): Observable<any> {
    console.log("Getting FORMS");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learner-portfolio/forms?_id=" + learnerId).subscribe((res: any) => {
        console.log("Get learners : ", res);
        observer.next(res.data);
        observer.complete();
      })

    });

  }


  // EVIDENCE

  addEvidence(data: any): Observable<any> {
    console.log("Adding EVIDENCES", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learner-portfolio/evidence", data).subscribe((res: any) => {

        observer.next(res);
        this.newEvidence.next(res);
        observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }



  allEvidenceDownload(data: any): Observable<any> {
    console.log("Adding EVIDENCES", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learner-portfolio/evidence-download", data).subscribe((res: any) => {

        observer.next(res);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }


  editEvidenceObservable(): Observable<any> {
    return this.editEvidences.asObservable();
  }


  editEvidence(data: any): Observable<any> {
    console.log("Edit learners", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "learner-portfolio/evidence", data).subscribe((res: any) => {
        console.log("Edited Evidence : ", res);
        this.editEvidences.next(res.data)
        // this.editEvidences.complete()
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }


  removeEvidenceObservable(): Observable<any> {
    return this.removeEvidence.asObservable();
  }

  deleteEvidence(evidenceId, learnerId, jobId) {
    console.log("Hello here is Job Id:", jobId)
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "learner-portfolio/evidence?evidenceId=" + evidenceId + '&learnerId=' + learnerId + '&jobId=' + jobId).subscribe((res: any) => {
        observer.next(res.data);
        this.removeEvidence.next(res.data);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }



  getEvidenceByLearner(learnerId, jobId) {
    console.log("Getting learners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learner-portfolio/evidence?learnerId=" + learnerId + "&jobId=" + jobId).subscribe((res: any) => {
        console.log("Get learners : ", res);
        observer.next(res.data);
        observer.complete();
      })

    });
  }

  // GENERATE LEARNER PDF
  getPdfByLearner(data) {
    console.log("getPdfByLearner");
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learner-portfolio/pdf", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  generateProtfolios(data) {
    console.log("getPdfByLearner");
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "learner-portfolio/genrate-all-pdf/?jobId" + data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  getPolicyData(jobId, learnerId) {
    console.log("getPolicyData");
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "learner-portfolio/policy?jobId=" + jobId + "&learnerId=" + learnerId).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  instructorJobs(jobs) {
    console.log("response of jobs", jobs);

    this.learnerSubject.next({ jobs })
  }
  displayLearnerJobs(): Observable<any> {
    return this.learnerSubject.asObservable();
  }


  singleJob(jobId) {
    console.log("response of jobs", jobId);
    this.singleJobDetails.next({ jobId })
  }
  getSingleJobId(): Observable<any> {
    return this.singleJobDetails.asObservable();
  }




  updateTotalOTJH(data) {
    console.log("getPdfByLearner");
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "learners/update-otjh", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }



  getUserRole(Id) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/learner-role?_id=" + Id).subscribe((res: any) => {
        console.log("Get PORTFOLIO : ", res);
        observer.next(res.data.response);
        observer.complete();
      })
    });
  }




  // DOWNLOAD PDF
  downloadPdfByLearner(learnerId, jobId) {
    console.log("Getting learners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learner-portfolio/pdf-download?learnerId=" + learnerId + "&jobId=" + jobId).subscribe((res: any) => {
        console.log("Get PORTFOLIO : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  /**
   * Attendance Functions
   */

  getAttendance(jobId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "learners/attendance?jobId=" + jobId).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  addAttendance(data) {
    console.log("getPdfByLearner");
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "learners/attendance", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }



  getRemark(data: any): Observable<any> {
    console.log("Adding Time", data);
    return new Observable<any>((observer) => {
      console.log("Observable get remark");
      var that = this;
      this.http.post(config.baseApiUrl + "learners/allot-remark", data).subscribe((res: any) => {

        observer.next(res);
        console.log("response from service for remark", res);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED response is remark")
          observer.complete();
        })

    });
  }



  displayFile(data) {
    console.log("check data", data);

    this.fileDetails.next(data)

  }



  fileDetailsObservable(): Observable<any> {
    return this.fileDetails.asObservable();
  }


  /**
   * @param data details of download learner all documents
   * @returns Buffer data of zip file or if it will take too long time to generate than send it to the mail
   */
  downloadLearnerDocuments(data): Observable<any> {
    console.log("Adding Time", data);
    return new Observable<any>((observer) => {
      console.log("Observable get remark");
      var that = this;
      this.http.get(config.baseApiUrl + "learners/download-all-documents?download=" + JSON.stringify(data)).subscribe((res: any) => {

        observer.next(res);
        console.log("response from service for remark", res);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED response is remark")
          observer.complete();
        })

    });
  }

  getAllLearners(): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable get remark");
      this.http.get(config.baseApiUrl + "learners/all-learner-list").subscribe((res: any) => {
        observer.next(res);
        console.log("response from service for remark", res);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED response is remark")
          observer.complete();
        })

    });
  }

}
